'use client';

import Image from 'next/image';

import {
  PrimeiroAcessoForm,
  SplashScreen,
  StyledGridBox,
  StyledHeader,
  StyledLoginFormBox,
  StyledTextCall,
  StyledThemeButtonBox,
} from '~/entities';
import { ThemeButton } from '~/features';

export function PrimeiroAcessoView() {
  return (
    <StyledGridBox>
      <StyledThemeButtonBox>
        <ThemeButton />
      </StyledThemeButtonBox>
      <SplashScreen />
      <StyledLoginFormBox>
        <Image
          className="mobile-logo"
          src="/static/logo_martins_ads.svg"
          alt="Logo da Martins Ads"
          width={100}
          height={103}
        />
        <StyledHeader variant="h1">Primeiro acesso</StyledHeader>
        <StyledTextCall>
          Cadastre uma nova senha para acessar a sua conta.
        </StyledTextCall>

        <PrimeiroAcessoForm />
      </StyledLoginFormBox>
    </StyledGridBox>
  );
}
